import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

// components
import Typography from '@mui/material/Typography'

const LegacyAllergiesWarning = props => {
  const { type, allergies, allergiesOther } = props

  // build a list of all legacy allergies, and reject null values
  const allergyList = allergies
    .concat([allergiesOther])
    .filter(value => !!value)
    .join(', ')

  return (
    <Box mt={4} mb={2}>
      <Card>
        <CardContent>
          <Typography paragraph color='error.main' fontWeight='fontWeightBold'>
            We are now providing more clarity to staff about the type and
            severity of camper allergies. Please update the form below with
            current {type} allergy information. You previously listed the
            following allergies:
          </Typography>
          <Typography>{allergyList}</Typography>
        </CardContent>
      </Card>
    </Box>
  )
}

export default LegacyAllergiesWarning
